import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AddInteractionService} from '../../../shared/services/interaction/add-interaction.service';
import {ENTRY_STATES} from '../../../shared/types/entry/EntryStatesEnum';
import {InteractionData} from '../../../shared/types/interaction/interaction-data';

@Component({
  selector: 'wsd-organization-interactions',
  templateUrl: './organization-interactions.component.html',
  styleUrls: ['./organization-interactions.component.css']
})
export class OrganizationInteractionsComponent {

  @Input()
  interactions: InteractionData[];

  @Output()
  onNewInteraction = new EventEmitter();

  @Output()
  onInteractionDelete = new EventEmitter();

  pageSize: number = 5;

  constructor(private addInteractionService: AddInteractionService) {
  }

  add() {
    this.addInteractionService.create();
  }

  modify(interaction: InteractionData) {
    this.addInteractionService.modify(interaction);
  }

  delete(interaction: InteractionData) {
    this.interactions.splice(this.interactions.indexOf(interaction), 1);
    this.onInteractionDelete.emit();
  }

  onSave(interaction: InteractionData) {
    if (interaction.$state === ENTRY_STATES.NEW) {
      this.interactions.push(interaction);
      this.onNewInteraction.emit();
    } else {
      this.addInteractionService.modify(interaction);
      this.onNewInteraction.emit();
    }
  }
}
